import { applicationVersionDetail, applicationVersionSchedule } from './request';
export default {
  data() {
    return {
      scheduleList: [],
      dataFrom: {},
      versionId: '',
      dialogVisible: false
    };
  },
  methods: {
    init(data) {
      this.versionId = data.versionId;
      applicationVersionDetail({
        versionId: data.versionId
      }).then(res => {
        console.log(res);
        this.dataFrom = res;
        if (res.isExistAuditFlow) {
          this.scheduleFun();
        }
      });
      this.dialogVisible = true;
    },
    scheduleFun() {
      applicationVersionSchedule({
        versionId: this.versionId
      }).then(res => {
        console.log(res, 8);
        this.scheduleList = res;
      });
    }
  }
};